module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "topic-mapping"
    }
  }, [_vm._l((_vm.groups), function(group, index) {
    return _c('div', {
      key: index
    }, [_c('h1', {
      staticClass: "page-header"
    }, [_vm._v(_vm._s(group.name))]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, _vm._l((group.grades), function(grade, gradeIndex) {
      return _c('div', {
        key: gradeIndex,
        staticClass: "col-md-4 col-sm-12"
      }, [_c('div', {
        staticClass: "widget widget-stats",
        class: _vm.bgColor(grade)
      }, [_c('div', {
        staticClass: "stats-icon"
      }), _vm._v(" "), _c('div', {
        staticClass: "stats-info"
      }, [_c('h4', [_vm._v(_vm._s(grade.jenjang.nama))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(grade.display_name))])]), _vm._v(" "), _c('div', {
        staticClass: "stats-link"
      }, [(grade.jenjang.nama !== 'SMA') ? _c('router-link', {
        attrs: {
          "to": {
            path: '/topic-mapping/detail',
            query: {
              interest: 'DEFAULT',
              grade_id: grade.id
            }
          }
        }
      }, [_vm._v("Lihat Detail "), _c('i', {
        staticClass: "fa fa-arrow-circle-o-right"
      })]) : _c('a', {
        attrs: {
          "href": "#"
        },
        on: {
          "click": function($event) {
            return _vm.mappingDetail(grade)
          }
        }
      }, [_vm._v("Lihat Detail "), _c('i', {
        staticClass: "fa fa-arrow-circle-o-right"
      })])], 1)])])
    }), 0)])
  }), _vm._v(" "), (_vm.showModal) ? _c('app-modal', {
    attrs: {
      "cancelOnly": true
    },
    on: {
      "cancel": function($event) {
        _vm.showModal = false
      }
    }
  }, [_c('h4', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("Pilih Peminatan")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('router-link', {
    staticClass: "btn btn-lg btn-inverse",
    attrs: {
      "to": {
        path: '/topic-mapping/detail',
        query: {
          interest: 'SAINTEK',
          grade_id: _vm.selectedGrade.id
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-flask fa-2x pull-left"
  }), _vm._v("\n        " + _vm._s(_vm.selectedGrade.display_name)), _c('br'), _vm._v(" "), _c('small', [_vm._v("IPA")])]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-lg btn-inverse",
    attrs: {
      "to": {
        path: '/topic-mapping/detail',
        query: {
          interest: 'SOSHUM',
          grade_id: _vm.selectedGrade.id
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-child fa-2x pull-left"
  }), _vm._v("\n        " + _vm._s(_vm.selectedGrade.display_name)), _c('br'), _vm._v(" "), _c('small', [_vm._v("IPS")])])], 1)]) : _vm._e(), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-20d21ce2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/kodifikasi/TopicMapping.vue
// module id = 1301
// module chunks = 0